import * as types from '../../lib/actionTypes.es6';

export const initialState = {
  errors: null,
  closedClaimList: null,
  loader: false,
};

export default function closedClaimReducer(state = initialState, action) {
  switch (action.type) {
    case types.CLOSED_CLAIM_REQUEST:
      return { ...initialState, loader: true };

    case types.CLOSED_CLAIM_SUCCESS:
      return { ...state, closedClaimList: action.payload, loader: false };

    case types.CLOSED_CLAIM_FAIL:
      return {
        ...state,
        loader: false,
        errors: action.payload,
        closedClaimList: null,
      };

    case types.USER_LOGOUT:
      return initialState;

    default:
      return state;
  }
}
